<div class="fundo-loading" *ngIf="show" style="z-index: 9999 !important;">
    <div class="loader">Loading...</div>
</div>
